export const props = {
  slug: {
    type: String,
    required: true
  }
}
